import * as R from 'ramda';
import { FormContext } from './form-context';
import { createFormulaElementDefFn, mapFormulaElementToFormElement, createFormCalculatorFrame, } from '../utils/calc.utils';
import { FormulaChangeProperty, FormElementChangedBy, } from '../../models';
var FormCalculatorContext = /** @class */ (function () {
    function FormCalculatorContext(context) {
        var _this = this;
        this.context = context;
        // calc in progress flag
        this.calculation = false;
        // calc in progress async change keys
        this.asyncChangeKeys = new Set();
        // form calculation
        this.calcFormDefinitionIteratively = function (element, i) {
            if (i === void 0) { i = 0; }
            if (i === 100) {
                console.error('Maximum form calculation iterations call stack size exceeded');
                _this.formulaDefinition = element;
                return mapFormulaElementToFormElement(element);
            }
            // calc form elements
            var changed = false;
            _this.calculationFrame.forEach(function (calc) { return (changed = calc() || changed); });
            // next form definition
            if (!changed) {
                _this.formulaDefinition = element;
                return mapFormulaElementToFormElement(element);
            }
            return _this.calcFormDefinitionIteratively(element, i + 1);
        };
        // element async change
        this.handleAsyncPropertyChange = R.curry(function (id, key, value) {
            _this.context.handleAsyncPropertyChange(id, key, value);
            if (_this.calculation) {
                var changeKey = FormContext.mapAsyncChangeKey(id, key);
                _this.asyncChangeKeys.add(changeKey);
            }
        });
        // mark change as sync, to cancel async change
        this.markPropertyChangeAsSync = R.curry(function (id, key) {
            _this.context.markPropertyChangeAsSync(id, key);
            if (_this.calculation) {
                var changeKey = FormContext.mapAsyncChangeKey(id, key);
                _this.asyncChangeKeys.delete(changeKey);
            }
        });
        // init create form definition for formulas function
        this.createFormulaDefinition = R.pipe(createFormulaElementDefFn({
            isElementValid: context.isElementValid.bind(context),
            isElementValueChanged: this.isElementValueChanged.bind(this),
            isElementValueFetching: context.isElementValueFetching.bind(context),
            isElementTouched: context.isElementTouched.bind(context),
        }), R.tap(function (next) {
            _this.formulaDefinition = next;
            _this.calculationFrame = createFormCalculatorFrame(_this, next);
        }));
        // init calc form function
        this.calcFormDefinition = R.pipe(function (def) { return def || _this.formulaDefinition; }, 
        // start calculation
        R.tap(function () { return (_this.calculation = true); }), 
        // form calculation
        this.calcFormDefinitionIteratively, 
        // stop calculation
        R.tap(function () {
            _this.calculation = false;
            _this.asyncChangeKeys.clear();
        }));
    }
    // is element value changed in the moment
    FormCalculatorContext.prototype.isElementValueChanged = function (element) {
        var changeKey = FormContext.mapAsyncChangeKey(element.id, FormulaChangeProperty.VALUE);
        if (this.asyncChangeKeys.has(changeKey)) {
            return FormElementChangedBy.FORMULA;
        }
        return this.context.isElementValueChanged(element);
    };
    FormCalculatorContext.prototype.clean = function () {
        this.formulaDefinition = null;
    };
    return FormCalculatorContext;
}());
export { FormCalculatorContext };
//# sourceMappingURL=form-calculator.js.map